import { render, staticRenderFns } from "./ArticlesPaginate.vue?vue&type=template&id=65f89740&"
import script from "./ArticlesPaginate.vue?vue&type=script&lang=js&"
export * from "./ArticlesPaginate.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesPaginate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports